<template>
  <div class="Shop">
      <div class="content">
          <div class="current-loc">
            <span>{{ $t('satellite.CurrentPosition') }}：</span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $t('personalCenter.productaudit') }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <p class="title">{{ $t('personalCenter.productaudit') }}</p>
          <div class="query">
                <el-select placeholder="请选择是否审核" size="mini" v-model="queryForm.approvalFlag" @change="changeFlag">
                    <el-option :label="$t('algorithm2.NotReviewed')" value="0"></el-option>
                    <el-option :label="$t('personalCenter.Audithasbeenpassed')" value="1"></el-option>
                    <el-option :label="$t('personalCenter.Auditfailed')" value="-1"></el-option>
                </el-select>
          </div>
          <div class="data-table">
              <el-table
                class="changeSkin"
                :header-cell-style="header_cell_style_bd"
                :cell-style="cell_style_bd"
                :style="cell_style_bd"
                :data="tableData"
                :empty-text="$t('Intelligent.NoData')"
                border
                ref="NewsTable"
                style="width: 100%;">
                <el-table-column
                :label="$t('DataSubmission.ProductName')"
                show-overflow-tooltip
                prop="dataName"
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('satellite.TimeRange')"
                show-overflow-tooltip
                prop="createTime"
                align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.productFileStartTime&&scope.row.productFileStartTime.length>0">{{scope.row.productFileStartTime}}{{$t('personalCenter.TO')}}{{scope.row.productFileEndTime}}</span>
                        <span v-else>未知</span>
                    </template>
                </el-table-column>
                <el-table-column
                :label="$t('product.ProductCategory')"
                prop="dataTypeName"
                show-overflow-tooltip
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('algorithm.Region')"
                prop="dataLocation"
                show-overflow-tooltip
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('DataSubmission.SharingLevel')"
                prop="dataShareLevelName"
                show-overflow-tooltip
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('product.Contact')"
                prop="dataPublishUser"
                show-overflow-tooltip
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('product.Institution')"
                prop="organizational"
                show-overflow-tooltip
                align="center">
                </el-table-column>
                <el-table-column
                :label="$t('DataSubmission.Operation')"
                prop="newsTitle"
                align="center">
                    <template slot-scope="scope">
                        <span v-if="queryForm.approvalFlag!='1'" @click="approval(scope.row)" style="cursor:pointer;color:rgb(51, 144, 248);">{{$t('personalCenter.audit')}}</span>
                        <span style="color:green;" v-else>{{$t('personalCenter.alreadypassed')}}</span>
                    </template>
                </el-table-column>
            </el-table>
          </div>
          <div class="pagenation">
                <el-pagination
                background
                :pager-count="7"
                :page-size="10"
                @current-change="currentChange"
                layout="prev, pager, next"
                :total="total">
                </el-pagination>
          </div>
      </div>
      <el-dialog
        :title="$t('personalCenter.productaudit')"
        :custom-class="themeStatis==='theme1'?'dialog-new-bg-b':'dialog-new-bg-w'"
        :visible.sync="showApproval"
        width="60%"
        center>
        <div>
            <div class="approval-main">
                <div class="info-top">
                    <div class="l">
                        <div class="title-p">
                            <span class="iconfont icon-jibenxinxi1"></span>
                          {{ $t('satellite.BasicInformation') }}</div>
                        <p>{{ $t('home.Datatime') }}：{{productBasiDetail.productFileStartTime}}{{ $t('personalCenter.TO') }}{{productBasiDetail.productFileEndTime}}</p>
                        <p>{{ $t('satellite.SpaceLocation') }}：{{productBasiDetail.dataLocation}}</p>
                        <p>{{ $t('product.SubjectCategory') }}：{{productBasiDetail.dataTypeName}}</p>
                        <p>{{ $t('personalCenter.dataformat') }}：{{productBasiDetail.dataFileType}}</p>
                        <p>{{ $t('Order.Numberofdata') }}：{{productBasiDetail.dataCount}}</p>
                    </div>
                    <div class="r">
                        <div class="title-p">
                            <span class="iconfont icon-jibenxinxi1"></span>
                          {{ $t('personalCenter.contactinformation') }}</div>
                        <p>{{ $t('product.Contact') }}：{{productBasiDetail.dataPublishUser}}</p>
                        <p>{{ $t('product.Phone') }}：{{productBasiDetail.phone}}</p>
                        <p>{{ $t('product.Mail') }}：{{productBasiDetail.email}}</p>
                        <p>{{ $t('product.Institution') }}：{{productBasiDetail.organizational}}</p>
                        <p>{{ $t('product.Address') }}：{{productBasiDetail.address}}</p>
                    </div>
                </div>
                <div class="data-bottom">
                    <div class="l">
                        <div class="title-p">
                            <span class="iconfont icon-jibenxinxi1"></span>
                          {{ $t('product.DataSummary') }}</div>
                        <p>{{productBasiDetail.dataDesc}}</p>
                    </div>
                    <div class="r">
                        <div class="title-p">
                            <span class="iconfont icon-jibenxinxi1"></span>
                          {{ $t('personalCenter.datapresentation') }}</div>
                        <div class="ditu">
                            <InitMapShowYX ref="InitMapShow" v-if="showApproval" :legendObj="legendObj" :url="imageServiceUrl" :collections="imageServiceCollections" initId="product"  :is2d="false" :timeRange="PlayTimeRange" :isplay="palyStatus"/>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display:flex;justify-content:center;">
                <el-button type="primary" @click="pass" style="margin-top:24px;" size="mini">{{ $t('algorithm2.Approved') }}</el-button>
                <el-button type="danger" @click="fail" style="margin-top:24px;" size="mini">{{ $t('personalCenter.nopass') }}</el-button>
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters} from "vuex";

import { 
    getApprovalList,
    getProductImageServiceInfo,
    getXQDataOption,
    productApproval,
} from "@/api/product/index"
import InitMapShowYX from "./productShow/initMapYX.vue"

export default {
    name:'Shop',
    components: {
        InitMapShowYX
    },
    data(){
        return{
            //地图1
            legendObj:{
                principalValue:"",
                startValue:"",
                endValue:"",
                type:1,
                valueStep:""
            },
            palyStatus:true,
            imageServiceUrl: '',
            imageServiceCollections: [
                {iserverImageType:'1'}
            ],
            PlayTimeRange:[],
            //地图2
            total:0,
            showApproval:false,
            productBasiDetail:{},
            productId:'',
            queryForm:{
                page:1,
                limit:9,
                productTypeId:'',
                topics:[],
                date:'', 
                approvalFlag:'0',
                productName:'',
                startTime:'',
                endTime:''
            },
            tableData: [],
        }
    },
    methods:{
        //查询影像服务地址和集合
        async getProductImageServiceInfoFuc(val) {
            let that = this
            let {data} = await getProductImageServiceInfo({productDataId: val})
            let res = data
            that.imageServiceUrl = res.productImagingService
            that.imageServiceCollections = res.productDataImagingResList

            if(res.productDataImagingResList[0].iserverImageType=='1'){
                let urlO = res.productImagingService+'/'+res.productDataImagingResList[0].resourceName+'/tempLayersSet?returnPostAction=true&getMethodForm=true'
                let xqOption = await getXQDataOption({urlPart:urlO})
                xqOption = JSON.parse(xqOption.data)
                that.imageServiceCollections[0].xqOption = xqOption
                console.log(xqOption);
            }
        },
        fail(){
            this.approvalFuc(-1)
        },
        pass(){
            this.approvalFuc(1)
        },
        async approvalFuc(val){
            let that = this
            let res = await productApproval(
                {
                    approvalFlag:val,
                    productDataId:that.productId
                }
            )
            if(res.code ==='000000'){
                that.$message.success('审核完成！')
                that.showApproval = false
            }
            that.getList()
        },
        changeFlag(val){
            console.log(val);
            this.queryForm.page = 1
            this.getList()
        },
        approval(val){
            this.showApproval = true
            console.log(val);
            this.productBasiDetail = val
            this.productId = val.pkid
            this.getProductImageServiceInfoFuc(val.pkid)
        },
        currentChange(val){
            this.queryForm.page = val
            this.getList()
        },
        async getList(){
            let that = this
            let {data} = await getApprovalList(that.queryForm)
            let res = data
            this.tableData = res.list
            this.total = parseFloat(res.totalCount)
        },
    },
    computed:{
        ...mapGetters(['header_cell_style_bd','cell_style_bd','themeStatis']),
    },
    created(){
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.approval-main{
    .title-p{
        color: #5DA2FF;
    }
    .info-top{
        display: flex;
    }
    .data-bottom{
        margin-top: 24px;
        display: flex;
        height: 224px;
    }
    .l , .r{
        flex: 1;
        p{
            margin-top: 6px;
        }
    }
}
.upload-pic{
    display: flex;
    justify-content: flex-end
}
.white-co{
    @include product_upload_label_co();
}
hr{
    @include hr_white_to_black();
}
.current-loc{
    height: 21px;
    display: flex;
    align-items: center;
    // margin-top: 60px;
    /deep/ span{
        font-size: 15px;
        @include co_white_to_black();
    }
    /deep/ a{
        @include co_white_to_black();
    }
    /deep/ .el-breadcrumb__item:last-child{
        span{
            color: rgba(38,125,255,1);
        }
    }
  }
.Shop{
    width: 100%;
    @include table_page_bg();
    @include co_white_to_black();
    .content{
        min-height: 659px;
        padding: 0 12px;
        margin: 0 auto;
        padding-bottom: 12px;
        .label{
            margin: 60px 0 20px 0;
        }
        .title{
            font-size: 28px;
            color: rgba(39,121,202,1);
            margin: 20px 0;
        }
        .query{
            display: flex;
            align-items: center;
            font-size: 15px;
            margin: 20px 0;
            .query-item{
                display: flex;
                align-items: center;
                height: 40px;
                margin-right: 24px;
                /deep/ .el-form-item__label{
                    @include co_white_to_black();
                }
            }
        }
        .data-table{
            margin: 20px 0;
            // height: 400px;
            .order-status1{
                width: 8px;
                height: 8px;
                border-radius: 50px;
                background: green;
                margin-right: 8px
            }
            
            .order-status2{
                @extend .order-status1;
                background: rgba(24,144,255,1);
            }
            .order-status3{
                @extend .order-status1;
                background: rgba(24,144,255,1);
            }
            .order-status{
            }
            .delete-detail{
                color: rgba(24,144,255,1);
                margin: 0 8px;
                cursor: pointer;
            }
        }
        .pagenation{
            display: flex;
            justify-content: flex-end;
            padding-right: 0;
            &-left{
                display: flex;
                align-items: center;
                .select-nums{
                    font-size: 15px;
                    margin-right: 12px;
                    padding: 0 24px;
                    height: 34px;
                    border-radius: 3px;
                    border: 1px solid rgba(186,231,255,1);
                    background-color: rgba(186,231,255,0.3);
                    display: flex;
                    align-items: center;
                    svg{
                        margin: 2px 8px 0 0 ;
                    }
                    .totals{
                        margin-left: 12px;
                    }
                    .nums{
                        color: rgba(24,144,255,1);
                    }
                }
            }
        }
    }
    .order-detail{
        width: 100%;
        height: 300px;
        /deep/ .el-form-item__content{
            line-height: 0;
        }
        ::v-deep .el-form-item:nth-child(4){
            margin-bottom: 12px;
        }
    }
    ::v-deep .btn-next{
        margin-right: 0;
    }
    ::v-deep .el-pagination{
        padding-right: 0;
    }
}
 /deep/ .el-table-column--selection{
    .cell{
        padding: 0 10px;
    }
}
/deep/ .el-form-item__label{
    @include product_upload_label_co();
}
/deep/ .el-dialog, .el-pager li{
    @include shop_dialog_bg();
}
/deep/ .el-dialog__title{
    @include product_upload_label_co();
}

.dialog-content{
  display: flex;
  flex-direction: column;

  .data-content{
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    justify-content: space-around;
    .info-col-div{
      flex: 1;
      overflow: hidden; 
      white-space: nowrap; 
      text-overflow: ellipsis;
    }
    .info-col-div3{
      width: 45%;
    }
  }
}
/deep/ .basic-info-detail .el-dialog__header{
  padding: 12px 30px !important;
  span{
    font-size: 15px;
  }

  .el-dialog__headerbtn{
      margin-top: -4px;
  }
}
/deep/.dialog-new-bg-w {
    background: white;
    .el-form-item__label{
        color: black
    }
    .el-dialog, .el-pager li{
        background: white
        
    }
    .el-dialog__title {
        color: black
    }
}
/deep/.dialog-new-bg-b {
    background: rgb(29, 29, 29);
    .el-form-item__label{
        color: white;
    }
    .el-dialog, .el-pager li{
        background: rgb(29, 29, 29)
        
    }
    .el-dialog__title {
        color: white;
    }
}
</style>